export const PERMISSIONS = {
  // Dashboard Permissions
  VIEW_DASHBOARD: 'dashboard.access',
  DASHBOARD_REPORTS: 'dashboard.reports',
  DASHBOARD_ANALYTICS: 'dashboard.analytics',

  // User Management Permissions
  MANAGE_USERS: 'users.read',
  CREATE_USERS: 'users.create',
  EDIT_USERS: 'users.update',
  DELETE_USERS: 'users.delete',

  // Role Management Permissions
  CREATE_ROLES: 'roles.create',
  READ_ROLES: 'roles.read',
  UPDATE_ROLES: 'roles.update',
  DELETE_ROLES: 'roles.delete',
  ASSIGN_ROLES: 'roles.assign',

  // Permission Management
  CREATE_PERMISSIONS: 'permissions.create',
  READ_PERMISSIONS: 'permissions.read',
  UPDATE_PERMISSIONS: 'permissions.update',
  DELETE_PERMISSIONS: 'permissions.delete',
  ASSIGN_PERMISSIONS: 'permissions.assign',

  // Store Management
  CREATE_STORES: 'stores.create',
  READ_STORES: 'stores.read',
  UPDATE_STORES: 'stores.update',
  DELETE_STORES: 'stores.delete',

  // Product Management
  CREATE_PRODUCTS: 'products.create',
  READ_PRODUCTS: 'products.read',
  UPDATE_PRODUCTS: 'products.update',
  DELETE_PRODUCTS: 'products.delete',

  // Sales Management
  CREATE_SALES: 'sales.create',
  READ_SALES: 'sales.read',
  UPDATE_SALES: 'sales.update',
  DELETE_SALES: 'sales.delete',
  MANAGE_SALES: 'sales.manage',
  COLLECT_PAYMENT: 'sales.collect_payment',

  // Inventory Management
  CREATE_INVENTORY: 'inventory.create',
  READ_INVENTORY: 'inventory.read',
  UPDATE_INVENTORY: 'inventory.update',
  DELETE_INVENTORY: 'inventory.delete',
  MANAGE_INVENTORY: 'inventory.manage',
  TRANSFER_INVENTORY: 'inventory.transfer',

  // Visits Management
  CREATE_VISITS: 'visits.create',
  READ_VISITS: 'visits.read',
  UPDATE_VISITS: 'visits.update',
  DELETE_VISITS: 'visits.delete',
  MANAGE_VISITS: 'visits.manage',

  // Distribution Management
  CREATE_DISTRIBUTION: 'distribution.create',
  READ_DISTRIBUTION: 'distribution.read',
  UPDATE_DISTRIBUTION: 'distribution.update',
  DELETE_DISTRIBUTION: 'distribution.delete',
  MANAGE_DISTRIBUTION: 'distribution.manage',

  // Brand Management
  CREATE_BRANDS: 'brands.create',
  READ_BRANDS: 'brands.read',
  UPDATE_BRANDS: 'brands.update',
  DELETE_BRANDS: 'brands.delete',

  // Tags Management
  CREATE_TAGS: 'tags.create',
  READ_TAGS: 'tags.read',
  UPDATE_TAGS: 'tags.update',
  DELETE_TAGS: 'tags.delete',

  // Billing Management
  BILLING_EXPORT: 'billing.export',
  BILLING_MANAGE: 'billing.manage',
  BILLING_APPROVE: 'billing.approve',
  BILLING_READ: 'billing.read',
  BILLING_CREATE: 'billing.create',
  BILLING_UPDATE: 'billing.update',
  BILLING_DELETE: 'billing.delete',

  // Financial Reports
  VIEW_FINANCIAL_REPORTS: 'dashboard.reports',
  VIEW_DASHBOARD_ANALYTICS: 'dashboard.analytics',
  VIEW_DASHBOARD_STATISTICS: 'dashboard.statistics',
  REPORTS_READ: 'reports.read',
  MANAGE_PAYMENTS: 'payments.manage',
  VIEW_AUDIT_LOGS: 'system.audit',

  // Mobile Access
  MOBILE_ACCESS: 'mobile.access',
  MOBILE_SALES: 'mobile.sales',
  MOBILE_VISITS: 'mobile.visits',

  // System Administration
  SYSTEM_SETTINGS: 'system.settings',
  SYSTEM_LOGS: 'system.logs',
  SYSTEM_BACKUP: 'system.backup',

  // Marketers Management
  READ_MARKETERS: 'marketers.read',
  CREATE_MARKETERS: 'marketers.create',
  UPDATE_MARKETERS: 'marketers.update',
  DELETE_MARKETERS: 'marketers.delete',
  MANAGE_MARKETERS: 'marketers.manage',

  // Service Providers Management
  READ_SERVICE_PROVIDERS: 'service_providers.read',
  CREATE_SERVICE_PROVIDERS: 'service_providers.create',
  UPDATE_SERVICE_PROVIDERS: 'service_providers.update',
  DELETE_SERVICE_PROVIDERS: 'service_providers.delete',
  MANAGE_SERVICE_PROVIDERS: 'service_providers.manage',

  // Marketer Tracking (daily location tracking feature — GO client)
  READ_LOCATION_TRACKING: 'location_tracking.read',
  EXPORT_LOCATION_TRACKING: 'location_tracking.export',

  // Checklists (CR09 — Salam dynamic checklist engine). Names MUST match the
  // backend permissions.name DB column (dotted resource.action).
  READ_CHECKLISTS: 'checklists.read',
  CREATE_CHECKLISTS: 'checklists.create',
  UPDATE_CHECKLISTS: 'checklists.update',
  DELETE_CHECKLISTS: 'checklists.delete',
  // Phase 2 — per-visit filled-checklist results (visit detail view).
  READ_CHECKLIST_SUBMISSIONS: 'checklist_submissions.read',

  // Legacy permissions for backward compatibility
  MANAGE_PRODUCTS: 'products.manage',
  MANAGE_STORES: 'stores.manage',
  MANAGE_BILLING: 'billing.manage'
};

// REMOVED: ROLE_PERMISSIONS - All role permissions are now loaded dynamically from API
// This ensures no hardcoded role-permission mappings and everything is managed through the backend
